// Vendors
import $ from 'jquery';
import 'waypoints/lib/jquery.waypoints.min';

const selectorClassName = 'site-header__bottom';
const selector = `.${selectorClassName}`;

// Create waypoint for site header bottom
$(selector).waypoint(
  (direction) =>
    $('body').toggleClass(
      `${selectorClassName}--is-stuck`,
      direction === 'down'
    ),
  { offset: 0 }
);

// Create waypoint for site header bottom
const sidebar_selectorClassName = 'page-content--sidebar';
const sidebar_selector = `.${sidebar_selectorClassName}`;
$(sidebar_selector).waypoint(
  (direction) =>
    $('body').toggleClass(
      `${sidebar_selectorClassName}--is-stuck`,
      direction === 'down'
    ),
  { offset: 0 }
  // { offset: 'bottom-in-view'}
);

$(sidebar_selector).waypoint(
  (direction) =>
    $('body').toggleClass(
      `${sidebar_selectorClassName}--at-bottom`,
      direction === 'down'
    ),
  { offset: 'bottom-in-view' }
);

// Refresh site header waypoint after translate drawer is opened/closed
$(
  '[data-toggle-target="translate-drawer"]'
).on('toggle:afterShow toggle:afterHide', (event) =>
  window.Waypoint.refreshAll()
);
